import { Box } from '@mui/material';

import { SCHEDULE_ACTIVITY_COLORS, SCHEDULE_ACTIVITY_OPTIONS } from '../constants';
import { SCHEDULE_ACTIVITY_COLOR_DOT_SX, SCHEDULE_ACTIVITY_SELECT_VALUE_SX } from '../styles';

import type { ScheduleActivitySelectValueProps } from './types';

export default function ScheduleActivitySelectValue({ value }: ScheduleActivitySelectValueProps) {
  const selectedOption = SCHEDULE_ACTIVITY_OPTIONS.find((option) => option.value === value);

  if (selectedOption == null) {
    return 'Select activity';
  }

  return (
    <Box sx={SCHEDULE_ACTIVITY_SELECT_VALUE_SX}>
      <Box
        aria-hidden
        sx={[
          SCHEDULE_ACTIVITY_COLOR_DOT_SX,
          { backgroundColor: SCHEDULE_ACTIVITY_COLORS[selectedOption.value] },
        ]}
      />
      {selectedOption.label}
    </Box>
  );
}
